/* eslint-disable react-hooks/exhaustive-deps */
import { useState } from "react";
import { useRef, useEffect } from "react";
function CourseContentNotice({ notice, setNotice, topZeroSure, start }) {

    const noticeScrollTop = useRef();
    useEffect(() => {
        if (topZeroSure === true && start === true) {
            setNotice(
                noticeScrollTop.current.getBoundingClientRect().top
            );
        }
    }, [topZeroSure, start]);



    const [displayNone, setdisplayNone] = useState(false);
    return (
        <div id="CourseContentNotice" >
            <div
                className="CourseContentItem"
                style={{ marginTop: 30 }}
            >
                <div className="d-flex f-aic CourseContentItem-wrap" ref={noticeScrollTop}>
                    <div className="d-flex CourseContent-title">
                        <svg
                            width="24"
                            height="29"
                            viewBox="0 0 24 29"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M13.1479 1.41773C12.7282 1.1025 11.6874 0.661183 10.8816 1.41773C10.0759 2.17427 10.378 3.15147 10.6298 3.5455C10.2101 3.4667 9.16929 3.49822 8.3635 4.25476C7.55772 5.01131 8.02776 5.98851 8.3635 6.38254C7.8599 6.14612 6.70162 5.95699 6.09728 7.0918C5.49294 8.22662 6.18121 9.14077 6.60089 9.456"
                                stroke="#B79973"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M14.7677 5.35017C14.3449 5.18916 13.4149 5.06034 13.0767 5.83321C12.7385 6.60608 13.2176 7.44335 13.4994 7.76538C13.1471 7.52386 12.3157 7.18573 11.8084 7.76538C11.3011 8.34503 11.5971 9.134 11.8084 9.45603"
                                stroke="#B79973"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <mask id="path-3-inside-1_1908_3273" fill="white">
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M1.77441 16.9679C3.21155 15.4747 6.49363 14.4312 10.3126 14.4312C14.1316 14.4312 17.4136 15.4747 18.8508 16.9679C17.4136 18.4612 14.1316 19.5047 10.3126 19.5047C6.49363 19.5047 3.21155 18.4612 1.77441 16.9679Z"
                                />
                            </mask>
                            <path
                                d="M1.77441 16.9679L1.0539 16.2745L0.386513 16.9679L1.0539 17.6614L1.77441 16.9679ZM18.8508 16.9679L19.5713 17.6614L20.2387 16.9679L19.5713 16.2745L18.8508 16.9679ZM2.49493 17.6614C3.0488 17.0859 4.04821 16.5183 5.44021 16.0966C6.81342 15.6807 8.48992 15.4312 10.3126 15.4312V13.4312C8.31631 13.4312 6.44229 13.7034 4.86043 14.1825C3.29736 14.656 1.93716 15.3567 1.0539 16.2745L2.49493 17.6614ZM10.3126 15.4312C12.1353 15.4312 13.8118 15.6807 15.185 16.0966C16.577 16.5183 17.5764 17.0859 18.1303 17.6614L19.5713 16.2745C18.688 15.3567 17.3278 14.656 15.7648 14.1825C14.1829 13.7034 12.3089 13.4312 10.3126 13.4312V15.4312ZM18.1303 16.2745C17.5764 16.85 16.577 17.4176 15.185 17.8392C13.8118 18.2552 12.1353 18.5047 10.3126 18.5047V20.5047C12.3089 20.5047 14.1829 20.2325 15.7648 19.7533C17.3278 19.2799 18.688 18.5791 19.5713 17.6614L18.1303 16.2745ZM10.3126 18.5047C8.48992 18.5047 6.81342 18.2552 5.44021 17.8392C4.04821 17.4176 3.0488 16.85 2.49493 16.2745L1.0539 17.6614C1.93716 18.5791 3.29736 19.2799 4.86043 19.7533C6.44229 20.2325 8.31631 20.5047 10.3126 20.5047V18.5047Z"
                                fill="#B79973"
                                mask="url(#path-3-inside-1_1908_3273)"
                            />
                            <path
                                d="M19.1263 15.2768C19.1263 16.1274 18.3439 17.0612 16.6918 17.8112C15.0851 18.5406 12.8304 19.0048 10.3131 19.0048C7.79588 19.0048 5.54114 18.5406 3.93444 17.8112C2.28239 17.0612 1.5 16.1274 1.5 15.2768C1.5 14.4263 2.28239 13.4925 3.93444 12.7425C5.54114 12.013 7.79588 11.5488 10.3131 11.5488C12.8304 11.5488 15.0851 12.013 16.6918 12.7425C18.3439 13.4925 19.1263 14.4263 19.1263 15.2768Z"
                                stroke="#B79973"
                            />
                            <path
                                d="M1.40486 15.6992C0.729996 19.9272 1.40486 28.3832 9.50324 28.3832C19.6262 28.3832 19.2214 22.0412 19.2214 15.6992"
                                stroke="#B79973"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M19.2212 17.8136C20.571 17.3908 23.2704 17.3062 23.2704 20.3504C23.2704 24.1556 20.436 25.8468 17.6016 25.424"
                                stroke="#B79973"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>

                        <div style={{ paddingLeft: 17 }}>注意事項</div>
                    </div>
                    <div className={` ${displayNone ? "arrow-icon-down" : 'arrow-icon'}`} onClick={() => setdisplayNone(!displayNone)}>

                    </div>
                </div>
                <div className={`CourseContent-text CourseContent-text-color ${displayNone ? "CourseContentItem-text" : ""}`}>
                    為防範新型冠狀病毒及配合政府防疫，講師與工作人員已完成疫苗三劑施打，主辦單位課程措施如下，請學員務必配合：
                    <br />
                    ‧授課期間，請學員自備口罩，除飲食外需全程配戴。
                    <br />
                    ‧入場前，請先進行額溫量測。若體溫超過37.5度，不予入場，並辦理全額退費。
                    <br />
                    ‧請使用主辦單位提供之酒精清潔手部。
                    <br />
                    ‧課程人數不超過10位，課程地點寬敞，並開設多處窗戶以保持環境通風。
                    <br />
                    ‧杯測教學時，每位學員備有獨立杯測桌、杯測勺等相關器材，不會與其他學員交叉杯測。
                    <br />
                    ‧務必提早十分鐘抵達指定地點，逾時不候。
                    <br />
                    ‧若有陪同者，需額外滿足店內低消。
                    <br />
                    ‧若遇不可預期之天災，如颱風、地震，主辦單位保有改期、改變體驗內容等權利。
                </div>
            </div>
        </div>
    );
}

export default CourseContentNotice;
